import React from 'react';
import styled from 'styled-components';
import { CaptionText, FlexBox, NavLink } from '@make-software/cspr-design';

import { PRIVACY_POLICY_PATH, TERMS_OF_SERVICE_PATH } from '@/paths';

export const FooterBackground = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundQuaternary,
    width: '100%',
    flexDirection: ['row'],
    justifyContent: 'center'
  })
);

export const FooterContainer = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    maxWidth: 1176,
    width: '100%',
    flexDirection: ['column', 'row'],
    justifyContent: 'flex-end',
    padding: ['24px 28px', '24px 32px', '24px 56px', '24px 0px'],
    '> * + *': {
      marginTop: [32, 0],
      marginLeft: [0, 16, 20, 24]
    }
  })
);


export const PageFooter: React.FC = () => {
  return (
    <FooterBackground>
      <FooterContainer>
        <CaptionText variation="darkGray" size={2}>
          <NavLink href={PRIVACY_POLICY_PATH}>Privacy Policy</NavLink>
        </CaptionText>
        <CaptionText variation="darkGray" size={2}>
          <NavLink href={TERMS_OF_SERVICE_PATH}>Terms of Service</NavLink>
        </CaptionText>
        <CaptionText variation="darkGray" size={2}>
          © 2025 ChainMail
        </CaptionText>
      </FooterContainer>
    </FooterBackground>
  );
};
